const CHOICE_LABELS_BY_LOCALE = {
    th: ["ก", "ข", "ค", "ง", "จ", "ฉ", "ช", "ซ", "ฌ", "ญ", "ฎ", "ฏ"],
    en: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
    cn: ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸", "子", "丑"],
} as const;

export const MAX_CHOICE_COUNT = CHOICE_LABELS_BY_LOCALE.th.length;

export function getChoiceLabels(locale: string): readonly string[] {
    if (locale === "en") {
        return CHOICE_LABELS_BY_LOCALE.en;
    }
    if (locale === "cn") {
        return CHOICE_LABELS_BY_LOCALE.cn;
    }
    return CHOICE_LABELS_BY_LOCALE.th;
}
